import styled from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
  width: 280px;
  flex: 0 0 auto;
`;
